import { useRouteMatch } from "react-router-dom";
import { useUserId } from "../../../query/hooks/helpers";
import { useMutationUpdateActivity } from "../../../query/users/mutations";
import { usePayrollFundingMethodsManagedByOrganization } from "../../../userFeatures/usePayrollFundingMethodsManagedByOrganization";
import { FlowAddFundingMethod } from "../../Settings/components/funding/FlowAddFundingMethod";
import { ManagedFundingMethod } from "../components/ManagedFundingMethod";

import { FlowStep } from "../../../shared/components/FlowSwitch/types";

export const PayrollFundingMethod: React.FC<FlowStep> = ({ onNext }) => {
  const match = useRouteMatch();
  const isManagedByOrg = usePayrollFundingMethodsManagedByOrganization();
  const userId = useUserId();
  const [updateActivity] = useMutationUpdateActivity(userId, {
    onSuccess: onNext
  });

  const handleSuccess = () => {
    updateActivity({
      events: {
        onboardingFundingMethodCompletedAt: new Date()
      }
    });
  };

  if (isManagedByOrg) {
    return <ManagedFundingMethod onContinue={handleSuccess} />;
  }

  return <FlowAddFundingMethod basePath={match.path} onNext={handleSuccess} />;
};
